export const DESIGN_STAGES = [
  { id: "initial_measurements", label: "Initial Site Measurements", short: "Site Measure" },
  { id: "design_iterations", label: "Design Iterations", short: "Design Sets" },
  { id: "twod_1st", label: "1st Set of 2D", short: "1st 2D" },
  { id: "twod_2nd", label: "2nd Set of 2D", short: "2nd 2D" },
  { id: "client_approved", label: "Client Approved", short: "Approved" },
  { id: "production_ready", label: "Production Ready", short: "Production" },
];

export const STAGE_INDEX = Object.fromEntries(DESIGN_STAGES.map((s, i) => [s.id, i]));

export const DESIGN_FILE_KINDS = [
  { id: "design_draft", label: "Design Draft", accept: "application/pdf,image/jpeg,image/png,image/webp,.dwg,.dxf", note: "Sent to Costing/Quotation team", multi: true, forward: "costing" },
  { id: "signoff_sheet", label: "Client Sign-Off Sheet", accept: "application/pdf,image/jpeg,image/png", note: "Pushed to client for digital approval", multi: false },
  { id: "offline_mom", label: "Offline Signed MOM", accept: "application/pdf,image/jpeg,image/png,image/webp,.dwg,.dxf", note: "Physical meeting sign-off (multiple sessions supported)", multi: true, grouped: true },
  { id: "final_execution_set", label: "Final Execution Sheet", accept: "application/pdf,image/jpeg,image/png,image/webp,.dwg,.dxf", note: "Locked. Unlocks Production Gate. Forwarded to IMOS team.", multi: true, forward: "imos" },
];

export const ALLOWED_DESIGN_EXT = [".pdf", ".jpg", ".jpeg", ".png", ".webp", ".dwg", ".dxf"];
export const MAX_DESIGN_FILE_BYTES = 25 * 1024 * 1024;

export function validateDesignFile(file) {
  const name = (file.name || "").toLowerCase();
  const okExt = ALLOWED_DESIGN_EXT.some((ext) => name.endsWith(ext));
  if (!okExt) return `Only PDF / DWG / DXF / JPG / PNG allowed: ${file.name}`;
  if (file.size > MAX_DESIGN_FILE_BYTES) return `File exceeds 25MB: ${file.name}`;
  return null;
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
